import { Route, Routes } from "react-router-dom";
import Sidenav from "./components/Sidenav";
import Home from "./pages/Home";
import CTA from "./pages/CTA";
import Users from "./pages/Users";
import Features from "./pages/Features";
import Settings from "./pages/Settings";
import Events from "./pages/Events";
import NewUser from "./pages/NewUser";
import SingleUser from "./pages/SingleUser";
import SingleEvent from "./pages/SingleEvent";
import NewEvent from "./pages/NewEvent";
import SingleFeature from "./pages/SingleFeature";
import NewFeature from "./pages/NewFeature";
import SingleCTA from "./pages/SingleCTA";
import NewCTA from "./pages/NewCTA";
import Header from "./components/Header";

function App() {
	return (
		<div className="App relative">
			<Header />
			<Sidenav />
			<Routes>
				<Route element={<Home />} path="/" />
				<Route element={<CTA />} path="/cta" />
				<Route element={<SingleCTA />} path="/cta/:id" />
				<Route element={<NewCTA />} path="/cta/new" />
				<Route element={<Users />} path="/users" />
				<Route element={<NewUser />} path="/users/new" />
				<Route element={<SingleUser />} path="/users/:id" />
				<Route element={<Features />} path="/features" />
				<Route element={<SingleFeature />} path="/features/:id" />
				<Route element={<NewFeature />} path="/features/new" />
				<Route element={<Settings />} path="/settings" />
				<Route element={<Events />} path="/events" />
				<Route element={<NewEvent />} path="/events/new" />
				<Route element={<SingleEvent />} path="/events/:id" />
			</Routes>
		</div>
	);
}

export default App;
